import { Product } from "../../../Redux/ecommersProduct/types";

const Brandproducts = ({ products }: { products: Product[] }) => {
  return (
    <>
      <div className=" display-max">
        <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-5 g-2">
          {products &&
            products.map((product, index) => {
              return (
                <>
                  <div className=" col">
                    <div className="card px-2 border-radius-0 shadow-none mb-lg-0">
                      <a href={`/DetailPage/${product._id}`}>
                        <div className="card-header p-0 position-relative border-radius-00 z-index-2 bg-gray">
                          <div className="d-block blur-shadow-image">
                            <img
                              src={product.mainImage}
                              alt="img-blur-shadow"
                              className="img-fluid-max-screens p-3"
                              loading="lazy"
                              onError={(e) => {
                                e.currentTarget.src =
                                  "../../assets/img/salarlogo.png";
                              }}
                            />
                          </div>
                        </div>
                      </a>
                      <div className="p-2 text-start lh-0">
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <b className="font-weight-bold mt-1 mb-1">
                              <a href={`/DetailPage/${product._id}`}>
                                {product.name.length > 15
                                  ? product.name.slice(0, 15) + "..."
                                  : product.name}
                              </a>
                            </b>
                          </div>
                          <div>
                            <span className="text-black text-xs">
                              <i className="bi bi-star-fill me-1 text-xxs"></i>
                              {product.reviews?.averageRating}
                            </span>
                          </div>
                        </div>
                        <div className=" mt-1">
                          <div className=" lh-1">
                            <b className="mt-2 fw-normal text-xxs text-black">
                              {product.description.length > 50
                                ? product.description.slice(0, 50) + "..."
                                : product.description}
                            </b>
                          </div>
                        </div>
                      </div>
                      <div className=" d-flex justify-content-between align-items-center mb-2 px-2">
                        <div>
                          <b className="font-bold fs-5 text-black my-auto">
                            <sup className=" fw-normal">₹</sup>{product.variations?.[0]?.pricing?.finalPrice}{" "}
                            <sub>
                              <b className="fw-normal text-black text-xxs">
                                MRP:{" "}
                              </b>{" "}
                              <b className="fw-normal text-black text-xxs text-decoration-line-through">
                                {product.variations?.[0]?.pricing?.unitPrice}
                              </b>
                            </sub>
                          </b>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
        </div>
      </div>
      <div className=" display-mini display-mob">
        <div className="row">
          {products &&
            products.map((product, index) => {
              return (
                <>
                  <div className="col-6">
                    <div className="card px-1 border-radius-0 shadow-none mb-lg-0">
                      <a href={`/DetailPage/${product._id}`}>
                        <div className="card-header p-0 position-relative border-radius-00 z-index-2 bg-gray">
                          <div className="d-block blur-shadow-image">
                            <img
                              src={product.mainImage}
                              alt="img-blur-shadow"
                              className="img-fluid-mini-screens p-1"
                              loading="lazy"
                               onError={(e) => {
                              e.currentTarget.src =
                                "../../assets/img/salarlogo.png";
                            }}
                            />
                          </div>
                        </div>
                      </a>
                      <div className="p-2 text-start lh-0">
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <b className="font-weight-bold mt-1 mb-1">
                              <a href={`/DetailPage/${product._id}`}>{product.name.length > 15
                                  ? product.name.slice(0, 15) + "..."
                                  : product.name}</a>
                            </b>
                          </div>
                          <div>
                            <span className="text-black text-xs">
                              <i className="bi bi-star-fill me-1 text-xxs"></i>
                              {product.reviews?.averageRating}
                            </span>
                          </div>
                        </div>
                        <div className=" mt-1">
                          <div className=" lh-1">
                            <b className="mt-1 fw-normal text-xxs text-black">
                              {product.description.length > 50
                                ? product.description.slice(0, 50) + "..."
                                : product.description}
                            </b>
                          </div>
                        </div>
                      </div>
                      <div className=" d-flex justify-content-between align-items-end mb-2 mt-2 px-2">
                        <div className=" lh-1">
                          <b className="font-bold fs-5 text-black my-auto">
                            <sup className=" fw-normal">₹</sup>{product.variations?.[0]?.pricing?.finalPrice}{" "}
                          </b>
                          <div>
                            {" "}
                            <sub>
                              <b className="fw-normal text-black text-xxs">
                                MRP:{" "}
                              </b>{" "}
                              <b className="fw-normal text-black text-xxs text-decoration-line-through">
                                {product.variations?.[0]?.pricing?.unitPrice}
                              </b>
                            </sub>
                          </div>
                        </div>
                       
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default Brandproducts;
